var md5 = require("md5");

const getGravatarUrl = name => {
  if (!name || name === "") return "";

  return `https://www.gravatar.com/avatar/${md5(name)}.png?s=150`;
};

export default getGravatarUrl;
